var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"header-panel__btn",class:{
        'header-panel__btn--open':_vm.PanelOpen,
    },on:{"click":function($event){$event.preventDefault();return _vm.togglePanel.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }